export const FormSections = {
    PRESCRIBER_AND_PATIENT: 1,
    MEDICATION_AND_DIAGNOSIS: 2,
    CLINICAL_INFORMATION: 3,
    PRESCRIBING_INFORMATION: 4,
    PLACE_OF_SERVICE_AND_DELIVERY: 5,
    REFERRAL_SUBMISSION: 6,
};

/* Schema for each section's captured data */
export const FormSectionDataSchema = {
    [FormSections.PRESCRIBER_AND_PATIENT]: {
        referralId: undefined,
        prescriberNpi: undefined,
        payerId: undefined,
        segmentId: undefined,
        firstName: undefined,
        memberId: undefined,
        memberDOB: undefined,
        prescriberName: undefined,
        prescriberPhone: undefined,
        practiceNpi: undefined,
        memberFirstName: undefined,
        memberLastName: undefined,
        memberAge: undefined,
        memberCity: undefined,
        memberState: undefined,
        memberZip: undefined,
        benefitAttributes: [],
        // Needed for referral form page header
        memberGender: undefined,
        segmentName: undefined,
        // Flag for if data is for referral pending reauth (needed to enable benefit check)
        pendingReauth: false,
        renewsReferralId: undefined,
    },
    [FormSections.MEDICATION_AND_DIAGNOSIS]: {
        productServiceOid: undefined,
        medication: undefined,
        diagnosisOid: undefined,
        diagnosisCode: undefined,
        diagnosisNotListed: [],
        diagnosisException: undefined,
    },
    [FormSections.CLINICAL_INFORMATION]: {
        clinicalPolicyAnswers: [],
        clinicalPolicyException: undefined,
    },
    [FormSections.PRESCRIBING_INFORMATION]: {
        billing: undefined,
        directionOption: undefined,
        manualDirectionText: undefined,
        strength: undefined,
        strengthUom: undefined,
        dosage: undefined,
        quantity: undefined,
        doseModifier: undefined,
        refills: undefined,
        dawCode: undefined,
        additionalMedications: [],
        specialInstructions: undefined,
    },
    [FormSections.PLACE_OF_SERVICE_AND_DELIVERY]: {
        placeOfService: undefined,
        facilityNpi: undefined,
        needsByDate: undefined,
        siteOfCareException: undefined,
    },
    [FormSections.REFERRAL_SUBMISSION]: {
        terms: [],
        sentToPharmacy: undefined,
        sentToAuthedPharmacy: undefined,
        sentToPharmacyNpi: undefined,
        sentToPharmacyNotListed: [],
        sentToPharmacyName: undefined,
        sentToPharmacyAddress: undefined,
        sentToPharmacyReason: undefined,
        pointOfContact: undefined,
        pointOfContactPhone: undefined,
        pointOfContactFax: undefined,
    },
};
